import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Sparkles, Loader2, Eye, EyeOff, Paperclip } from "lucide-react";
import { toast } from "sonner";

const ST = { eklendi: ["EKLENDİ", "text-emerald-400"], mevcut: ["ATLANDI", "text-amber-400"], okunamadi: ["OKUNAMADI", "text-rose-400"], bekliyor: ["BEKLİYOR", "text-slate-400"], taraniyor: ["TARANIYOR...", "text-sky-400"] };
export const n4 = (v) => (v == null ? "—" : Number(v).toLocaleString("tr-TR", { maximumFractionDigits: 4 }));
const WHY = "SİSTEM YAPAY ZEKASI YAZDIĞINIZ SİTELERİ OKUR; FİRMA ADI, YETKİLİ, GSM, SABİT TELEFON, E-POSTA, ADRES, İL VE İLÇE BİLGİLERİNİ KENDİSİ BULUP MÜŞTERİ LİSTENİZE EKLER. KAYITLI FİRMAYI TEKRAR EKLEMEZ, EKSİK BİLGİLERİ İŞARETLER. HER TARAMA YAPAY ZEKA SUNUCUSUNDA İŞLEM GÜCÜ HARCAR; KREDİ BU KULLANIM BEDELİDİR. API ANAHTARI, ABONELİK VEYA KURULUM GEREKMEZ. TEK TEK VEYA TOPLU TARAMADA FİYAT AYNIDIR, SADECE TARANAN SİTE KADAR KREDİ DÜŞER. AYNI KREDİYLE ÜSTTEKİ YAPAY ZEKAYA SOR DÜĞMESİ İLE HER KONUDA VE SİSTEMİN KULLANIMI HAKKINDA SORU SORABİLİRSİNİZ.";

export function SecretInput({ testid, value, onChange, placeholder }) {
  const [show, setShow] = useState(true);
  return (
    <div className="flex flex-1 gap-1">
      <Input data-testid={testid} type={show ? "text" : "password"} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="h-9 border-slate-700 bg-slate-800" />
      <Button data-testid={`${testid}-toggle`} type="button" onClick={() => setShow(!show)} title={show ? "GİZLE" : "GÖSTER"} className="h-9 bg-slate-700 px-2 hover:bg-slate-600">{show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}</Button>
    </div>
  );
}

export function UsageBar({ u }) {
  return (
    <div data-testid="ai-usage-bar" className="space-y-1">
      {u.uyari && <div data-testid="ai-credit-warning" className="rounded border border-rose-600 bg-rose-950/60 px-2 py-1.5 text-xs font-extrabold text-rose-200">DİKKAT: KALAN KREDİ ({n4(u.kalan)}) BELİRLEDİĞİNİZ SINIRIN ({n4(u.limit)}) ALTINA DÜŞTÜ — BAKİYE YÜKLEYİN</div>}
      <div className="flex flex-wrap gap-x-4 gap-y-1 rounded border border-fuchsia-900 bg-fuchsia-950/40 px-2 py-1.5 text-xs font-bold text-fuchsia-200">
        <span data-testid="ai-usage-last">BU SORGU: {n4(u.kredi)} KREDİ</span>
        <span data-testid="ai-usage-avg">ORTALAMA: {n4(u.ortalama)} KREDİ</span>
        <span data-testid="ai-usage-total">TOPLAM: {n4(u.toplam)} KREDİ / {u.sorgu} SORGU</span>
        <span data-testid="ai-usage-left">KALAN: {u.kalan == null ? "BAKİYE GİRİLMEDİ" : `${n4(u.kalan)} KREDİ`}</span>
        <span data-testid="ai-usage-left-q">KALAN SORGU: {u.kalan_sorgu == null ? "—" : `≈ ${u.kalan_sorgu.toLocaleString("tr-TR")}`}</span>
      </div>
    </div>
  );
}

const fmtD = (iso) => new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

function CreditMoves({ stamp }) {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { if (open) api.get("/ai-credits/moves").then((r) => setRows(r.data)); }, [open, stamp]);
  return (
    <details onToggle={(e) => setOpen(e.target.open)} className="rounded border border-slate-700 bg-slate-800/60 p-2 text-xs text-slate-300">
      <summary data-testid="ai-moves-toggle" className="cursor-pointer font-bold text-white">KREDİ HAREKETLERİ</summary>
      <div className="mt-2 max-h-48 overflow-auto">
        <table data-testid="ai-moves-table" className="w-full">
          <thead className="text-left text-slate-400"><tr><th className="py-1">TARİH</th><th>İŞLEM</th><th>SİTE / AÇIKLAMA</th><th>KULLANICI</th><th className="text-right">KREDİ</th><th className="text-right">BAKİYE</th></tr></thead>
          <tbody>
            {rows && rows.length === 0 && <tr><td colSpan={6} className="py-2 text-center text-slate-500">HAREKET YOK</td></tr>}
            {(rows || []).map((m, i) => (
              <tr key={i} data-testid={`ai-move-${i}`} className="border-t border-slate-700">
                <td className="py-0.5">{fmtD(m.at)}</td>
                <td className={m.kredi > 0 ? "font-bold text-emerald-400" : "text-slate-300"}>{m.tip}</td>
                <td className="max-w-[180px] truncate text-slate-400">{m.site}</td>
                <td>{m.by}</td>
                <td className={`text-right font-bold ${m.kredi > 0 ? "text-emerald-400" : "text-rose-300"}`}>{m.kredi > 0 ? "+" : ""}{n4(m.kredi)}</td>
                <td className="text-right">{n4(m.bakiye)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </details>
  );
}

function FirmCredits({ c, onSent }) {
  const [kredi, setKredi] = useState("10");
  const [acik, setAcik] = useState("");
  const [file, setFile] = useState(null);
  const k = parseInt(kredi, 10) || 0;
  const send = async () => {
    const fd = new FormData(); fd.append("kredi", String(k)); fd.append("aciklama", acik); if (file) fd.append("file", file);
    await api.post("/ai-credits/request", fd);
    toast.success("ÖDEME BİLDİRİMİ GÖNDERİLDİ — ONAY SONRASI KREDİ YÜKLENİR"); setAcik(""); setFile(null); onSent();
  };
  const pending = c.odemeler.filter((p) => p.durum === "BEKLİYOR");
  return (
    <div data-testid="ai-firm-credits" className="space-y-2">
      {c.bakiye <= 0 && c.sorgu > 0 && <div data-testid="ai-firm-credit-empty" className="rounded border border-rose-600 bg-rose-950/60 px-2 py-1.5 text-xs font-extrabold text-rose-200">KREDİNİZ BİTTİ — TARAMA YAPMAK İÇİN AŞAĞIDAN KREDİ ALIN</div>}
      {c.bakiye > 0 && c.bakiye < 1 && <div data-testid="ai-firm-credit-low" className="rounded border border-orange-600 bg-orange-950/60 px-2 py-1.5 text-xs font-extrabold text-orange-200">KREDİNİZ AZALDI — {n4(c.bakiye)} KREDİ KALDI (≈ {c.kalan_sorgu.toLocaleString("tr-TR")} SİTE). KESİNTİ OLMAMASI İÇİN ŞİMDİDEN KREDİ ALIN</div>}
      <div className="flex flex-wrap gap-x-4 rounded border border-fuchsia-900 bg-fuchsia-950/40 px-2 py-1.5 text-xs font-bold text-fuchsia-200">
        <span data-testid="ai-firm-balance">KREDİNİZ: {n4(c.bakiye)}</span>
        <span data-testid="ai-firm-left-q">KALAN SORGU: ≈ {c.kalan_sorgu.toLocaleString("tr-TR")} SİTE</span>
        <span>SİTE TARAMA: {n4(c.fiyat_tarama)} KREDİ</span>
        <span>SORU: {n4(c.fiyat_soru)} KREDİ (≈ {c.kalan_soru.toLocaleString("tr-TR")} SORU)</span>
        {c.kredi != null && <span data-testid="ai-firm-last">BU SORGU: {n4(c.kredi)} KREDİ</span>}
      </div>
      <details open={c.bakiye < 1} className="rounded border border-slate-700 bg-slate-800/60 p-2 text-xs text-slate-300">
        <summary data-testid="ai-buy-toggle" className="cursor-pointer font-bold text-white">KREDİ AL — EN AZ {c.min} KREDİ = {(c.min * c.fiyat_tl).toLocaleString("tr-TR")} TL (≈ {c.sorgu_10_kredi.toLocaleString("tr-TR")} SİTE VEYA ≈ {c.soru_10_kredi.toLocaleString("tr-TR")} SORU)</summary>
        <p className="my-2 leading-relaxed text-slate-400">{WHY}</p>
        <div data-testid="ai-buy-bank" className="mb-2 rounded bg-slate-900 p-2 font-mono text-slate-200">{c.iban ? <>{c.banka} · {c.hesap_adi}<br />IBAN: {c.iban}{c.bilgi && <><br />{c.bilgi}</>}</> : "BANKA BİLGİSİ HENÜZ GİRİLMEMİŞ"}</div>
        <div className="flex items-center gap-2">
          <Input data-testid="ai-buy-kredi" value={kredi} onChange={(e) => setKredi(e.target.value.replace(/\D/g, ""))} className="h-9 w-24 border-slate-700 bg-slate-900" />
          <span className="font-bold text-white">KREDİ = {(k * c.fiyat_tl).toLocaleString("tr-TR")} TL</span>
          <Input data-testid="ai-buy-note" value={acik} onChange={(e) => setAcik(e.target.value)} placeholder="AÇIKLAMA (GÖNDEREN AD / DEKONT NO)" className="h-9 flex-1 border-slate-700 bg-slate-900" />
          <label data-testid="ai-buy-file-label" className={`flex h-9 cursor-pointer items-center gap-1 rounded px-2 font-bold ${file ? "bg-emerald-800 text-emerald-100" : "bg-slate-700 text-slate-200 hover:bg-slate-600"}`}>
            <Paperclip className="h-4 w-4" /> {file ? "DEKONT EKLENDİ" : "DEKONT EKLE"}
            <input data-testid="ai-buy-file" type="file" accept="image/*,application/pdf" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} />
          </label>
          <Button data-testid="ai-buy-send" disabled={k < c.min} onClick={send} className="h-9 bg-emerald-600 hover:bg-emerald-700">ÖDEME BİLDİR</Button>
        </div>
        {pending.length > 0 && <div data-testid="ai-buy-pending" className="mt-2 font-bold text-amber-300">ONAY BEKLEYEN: {pending.map((p) => `${p.kredi} KREDİ`).join(", ")}</div>}
      </details>
      <CreditMoves stamp={c.sorgu + "-" + c.bakiye} />
    </div>
  );
}

export default function AiSitesModal({ open, onOpenChange, onDone, onManual }) {
  const { isSuperAdmin } = useAuth();
  const [system, setSystem] = useState(true);
  const [hasKey, setHasKey] = useState(null);
  const [pinSet, setPinSet] = useState(null);
  const [key, setKey] = useState("");
  const [pin, setPin] = useState("");
  const [sites, setSites] = useState("");
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const [usage, setUsage] = useState(null);
  const [firm, setFirm] = useState(null);
  const [drafts, setDrafts] = useState([]);
  const loadDrafts = () => api.get("/ai-site/drafts").then((r) => setDrafts(r.data));

  const loadFirm = () => api.get("/ai-credits/me").then((r) => setFirm(r.data));
  useEffect(() => {
    if (!open) return;
    loadDrafts();
    api.get("/ai-site/key").then((r) => setHasKey(r.data.configured));
    if (isSuperAdmin) { api.get("/ai-site/pin").then((r) => setPinSet(r.data.set)); api.get("/ai-site/usage").then((r) => setUsage(r.data)); }
    else loadFirm();
  }, [open, isSuperAdmin]);

  const saveKey = async () => { await api.put("/ai-site/key", { data: { key } }); setKey(""); setHasKey(true); toast.success("GEMINI ANAHTARI KAYDEDİLDİ"); };

  const delDraft = async (d) => { await api.delete(`/ai-site/drafts/${d.id}`); loadDrafts(); };
  const run = async (only) => {
    const list = only || [...new Set(sites.split("\n").map((s) => s.trim()).filter(Boolean))];
    if (!list.length) return;
    setBusy(true);
    const res = list.map((s) => ({ site: s, status: "bekliyor", detail: "" }));
    setRows([...res]);
    for (let i = 0; i < list.length; i++) {
      res[i] = { ...res[i], status: "taraniyor" }; setRows([...res]);
      try {
        const r = await api.post("/customers/from-site", { data: { url: list[i], system, pin } }, { silent: true });
        const d = r.data.data || {};
        const eksik = r.data.status === "eklendi" ? [!d.gsm && !d.s_tel && "TELEFON", !d.il && "İL"].filter(Boolean) : [];
        res[i] = { site: list[i], status: r.data.status, detail: r.data.detail || d.firma || "", kredi: r.data.usage?.kredi, eksik };
        if (r.data.usage) (isSuperAdmin ? setUsage : (u) => setFirm((f) => ({ ...f, ...u })))(r.data.usage);
      } catch (e) {
        const stop = [402, 403].includes(e.response?.status);
        res[i] = { site: list[i], status: "okunamadi", detail: e.response?.data?.detail || "HATA" };
        if (stop) { for (let j = i + 1; j < list.length; j++) res[j] = { ...res[j], status: "okunamadi", detail: res[i].detail }; setRows([...res]); break; }
      }
      setRows([...res]);
    }
    setBusy(false);
    toast.success(`${res.filter((x) => x.status === "eklendi").length} FİRMA MÜŞTERİ LİSTESİNE EKLENDİ`);
    if (!isSuperAdmin) loadFirm();
    loadDrafts();
    onDone?.();
  };

  const ready = system ? (isSuperAdmin ? pinSet && pin.trim() : firm?.bakiye > 0) : hasKey;
  const missing = rows.filter((r) => r.eksik?.length);

  return (
    <Dialog open={open} onOpenChange={(v) => !busy && onOpenChange(v)}>
      <DialogContent data-testid="ai-sites-modal" className="max-w-2xl border-slate-700 bg-slate-900 text-slate-100 [&>*]:min-w-0">
        <DialogHeader><DialogTitle className="font-head flex items-center gap-2"><Sparkles className="h-5 w-5 text-fuchsia-400" /> YAPAY ZEKA FİRMA EKLE</DialogTitle></DialogHeader>
        <div className="flex gap-1 text-xs font-bold">
          <button data-testid="ai-mode-system" onClick={() => setSystem(true)} className={`rounded px-3 py-1.5 ${system ? "bg-fuchsia-600 text-white" : "bg-slate-800 text-slate-300"}`}>SİSTEM YAPAY ZEKASI ({isSuperAdmin ? "PIN" : "KREDİ"})</button>
          <button data-testid="ai-mode-key" onClick={() => setSystem(false)} className={`rounded px-3 py-1.5 ${!system ? "bg-fuchsia-600 text-white" : "bg-slate-800 text-slate-300"}`}>GEMINI ANAHTARI</button>
        </div>
        {system && isSuperAdmin && (
          <div className="space-y-2">
            {pinSet === false ? <div className="text-xs font-bold text-amber-300">PIN BELİRLENMEMİŞ — AYARLAR › YAPAY ZEKA</div> : <SecretInput testid="ai-pin-input" value={pin} onChange={setPin} placeholder="PIN" />}
            {usage && <UsageBar u={usage} />}
          </div>
        )}
        {system && !isSuperAdmin && firm && <FirmCredits c={firm} onSent={loadFirm} />}
        {!system && (
          <div className="flex items-center gap-2">
            <SecretInput testid="ai-gemini-key-input" value={key} onChange={setKey} placeholder={hasKey ? "GEMINI ANAHTARI KAYITLI — DEĞİŞTİRMEK İÇİN YENİSİNİ YAZIN" : "GEMINI API ANAHTARINIZI YAPIŞTIRIN"} />
            <Button data-testid="ai-gemini-key-save" disabled={!key.trim()} onClick={saveKey} className="h-9 bg-slate-700 hover:bg-slate-600">KAYDET</Button>
          </div>
        )}
        <textarea data-testid="ai-sites-textarea" value={sites} onChange={(e) => setSites(e.target.value)} rows={6} placeholder={"HER SATIRA BİR SİTE YAZIN\nornekfirma.com.tr\nwww.baskafirma.com"} className="w-full rounded-md border border-slate-700 bg-slate-800 p-2 font-mono text-sm text-slate-100" />
        <Button data-testid="ai-sites-start" disabled={busy || !ready || !sites.trim()} onClick={() => run()} className="bg-fuchsia-600 text-white hover:bg-fuchsia-700">
          {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Sparkles className="mr-1 h-4 w-4" />} TARA VE MÜŞTERİ LİSTESİNE EKLE
        </Button>
        {drafts.length > 0 && (
          <details data-testid="ai-drafts" className="rounded border border-rose-900 bg-rose-950/30 p-2 text-xs">
            <summary className="cursor-pointer font-bold text-rose-200">TASLAKLAR — AÇILMAYAN / OKUNAMAYAN SİTELER ({drafts.length})</summary>
            <div className="mt-2 flex justify-end"><Button data-testid="ai-drafts-retry-all" disabled={busy || !ready} onClick={() => run(drafts.map((d) => d.site))} className="h-7 bg-fuchsia-700 px-2 text-xs hover:bg-fuchsia-600">TÜMÜNÜ TEKRAR DENE</Button></div>
            <div className="mt-1 max-h-48 overflow-auto">
              {drafts.map((d) => (
                <div key={d.id} data-testid={`ai-draft-${d.id}`} className="flex items-center gap-2 border-b border-rose-900/50 py-1">
                  <span className="w-44 truncate text-slate-200">{d.site}</span>
                  <span className="min-w-0 flex-1 truncate text-rose-300">{d.detail}</span>
                  <span className="text-slate-500">{d.deneme} DENEME</span>
                  <Button data-testid={`ai-draft-retry-${d.id}`} disabled={busy || !ready} onClick={() => run([d.site])} className="h-6 bg-slate-700 px-2 text-[11px] hover:bg-slate-600">TEKRAR DENE</Button>
                  {onManual && <Button data-testid={`ai-draft-manual-${d.id}`} disabled={busy} onClick={() => onManual(d)} className="h-6 bg-blue-700 px-2 text-[11px] hover:bg-blue-600">ELLE TAMAMLA</Button>}
                  <Button data-testid={`ai-draft-delete-${d.id}`} disabled={busy} onClick={() => delDraft(d)} className="h-6 bg-rose-800 px-2 text-[11px] hover:bg-rose-700">SİL</Button>
                </div>
              ))}
            </div>
          </details>
        )}
        {missing.length > 0 && <div data-testid="ai-missing-summary" className="rounded border border-orange-700 bg-orange-950/40 px-2 py-1.5 text-xs font-bold text-orange-200">{missing.length} FİRMA EKSİK BİLGİYLE EKLENDİ — MÜŞTERİ LİSTESİNDE TAMAMLAYIN: {missing.map((r) => r.detail).join(", ")}</div>}
        {rows.length > 0 && (
          <div data-testid="ai-sites-results" className="max-h-56 overflow-auto rounded border border-slate-800 text-xs">
            {rows.map((r, i) => (
              <div key={i} data-testid={`ai-site-row-${i}`} className="flex gap-2 border-b border-slate-800 px-2 py-1">
                <span className="w-48 truncate text-slate-300">{r.site}</span>
                <span className={`w-24 font-bold ${ST[r.status]?.[1]}`}>{ST[r.status]?.[0]}</span>
                <span className="min-w-0 flex-1 truncate text-slate-400">{r.detail}</span>
                {r.eksik?.length > 0 && <span data-testid={`ai-site-missing-${i}`} className="font-bold text-orange-400">EKSİK: {r.eksik.join(", ")}</span>}
                {r.kredi != null && <span className="text-fuchsia-300">{n4(r.kredi)} KREDİ</span>}
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
